import { forOwn } from './index';
export default function flattenObject(data, separator = '.') {
    if (!data) {
        return {};
    }
    return _flattenObject(data, separator, '', {}, [data]);
}
function _flattenObject(data, separator, prefix, flatData, cyclic) {
    if (prefix) {
        prefix += separator;
    }
    // Holds objects to be handled after all current level values/references are processed.
    const objects = {};
    forOwn(data, (value, key) => {
        if (typeof value === 'object' &&
            value !== null &&
            !(value instanceof String) &&
            !(value instanceof Number) &&
            !(value instanceof Boolean)) {
            if (cyclic.indexOf(value) > -1) {
                return;
            }
            cyclic.push(value);
            // Register object to handle AFTER all current level values/references.
            // As higher level references are preferred over nested cyclic references.
            objects[key] = value;
        }
        else {
            flatData[`${prefix}${key}`] = value;
        }
    });
    // Handle all objects recursively
    forOwn(objects, (value, key) => {
        _flattenObject(value, separator, `${prefix}${key}`, flatData, cyclic);
    });
    return flatData;
}
//# sourceMappingURL=flattenObject.js.map